module.exports = __webpack_public_path__ + "static/media/shipments_icon_blue.e7c95d33.png";